import React, { useState } from 'react';
import styles from '../../styles/components/sections/FAQSection.module.css';
import { useDarkMode } from '../../utils/hooks/useDarkMode';

/**
 * A reusable component that displays FAQs with expandable/collapsible answers
 *
 * @param {Object} props
 * @param {Object} props.data - The FAQ data from Strapi
 */
const FAQSection = ({ data }) => {
    const [openIndex, setOpenIndex] = useState(0);
    const { isDarkMode, isThemeInitialized } = useDarkMode();

    // Handle different possible data structures
    const faqs =
        data?.faqs || // Direct structure
        data?.attributes?.faqs || // Nested in attributes
        (Array.isArray(data) ? data : []); // Data is already an array of FAQs

    if (!faqs || faqs.length === 0) {
        return null;
    }

    const toggleFAQ = index => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <section className={`py-12 ${styles['faq-section']}`}>
                <div className="tw-container">
                    <div className="text-center mb-5">
                        <h2 className={styles.heading}>{data?.title }</h2>
                        <p className={styles.description}>{data?.description}</p>
                    </div>
                    
                    <div className={`${styles.accordion}`} id="faqAccordion">
                        {faqs?.map((item, index) => {
                            // Handle different possible field names for question and answer
                            const question = item.question || item.title || item.Question || 'FAQ Question';
                            const answer = item.answer || item.content || item.Answer || 'Answer not available';

                            // Skip hidden items
                            if (item?.isHidden) {
                                return null;
                            }

                            return (
                                <div key={index} className={`${styles['accordion-item']} mb-3`}>
                                    <div className={styles['accordion-header']}>
                                        <button
                                            className={`${styles['accordion-button']} ${openIndex === index ? styles['active'] : ''}`}
                                            type="button"
                                            onClick={() => toggleFAQ(index)}
                                            aria-expanded={openIndex === index}
                                            aria-controls={`faq-content-${index}`}>
                                            <span className={styles['question-text']}>{question}</span>
                                            <span className={`${styles['accordion-icon']} ${openIndex === index ? styles['rotated'] : ''}`}>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                    <div
                                        id={`faq-content-${index}`}
                                        className={`${styles['accordion-collapse']} ${openIndex === index ? styles['show'] : ''}`}
                                        aria-labelledby={`faq-${index}`}>
                                        <div className={styles['accordion-body']}>
                                            <p>{answer}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQSection;